import service from "@/store/services/event-custom-users-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  customUser: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, customUser) => {
    state.customUser = customUser;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((customUser) => {
      commit("SET_RESOURCE", customUser);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((customUser) => {
      commit("SET_RESOURCE", customUser);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((customUser) => {
      commit("SET_RESOURCE", customUser);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  customUser: (state) => state.customUser,
  url: (state) => state.url,
};

const customUsers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default customUsers;
